import request from '@/utils/request'

export function getAllScene(data) {
  return request({
    url: '/Api/brand.DepotScene/getBrandScene',
    method: 'post',
    data
  })
}

export function getSceneList(data) {
  return request({
    url: '/Api/brand.DepotScene/getBrandSceneList',
    method: 'post',
    data
  })
}

export function addScene(data) {
  return request({
    url: '/Api/brand.DepotScene/addScene',
    method: 'post',
    data
  })
}

export function editScene(data) {
  return request({
    url: '/Api/brand.DepotScene/editScene',
    method: 'post',
    data
  })
}

export function delScene(data) {
  return request({
    url: '/Api/brand.DepotScene/delScene',
    method: 'post',
    data
  })
}

export function getSceneInfoByIds(data) {
  return request({
    url: '/Api/brand.DepotScene/getSceneInfoByIds',
    method: 'post',
    data
  })
}
